import { API_URL, createRequestActionTypes } from "../../../actions/index";
export const GENERATE_TOKEN_URL = `${API_URL}/api/auth/generateToken`;

export const GENERATE_TOKEN_SUCCESS_MESSAGE = "Tensor Social API Access Granted";

export const settingsActionTypes = {
  generateToken: createRequestActionTypes("GENERATE_TOKEN"),
};
